import { render, staticRenderFns } from "./PodDocument.vue?vue&type=template&id=373c352c&"
import script from "./PodDocument.vue?vue&type=script&lang=js&"
export * from "./PodDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports